import { Pipe, PipeTransform } from '@angular/core';
import { Tenant } from '@mynexus/mynexus-ui-lib';



@Pipe({
    name: 'dataSourceTransform',
    standalone: false
})
export class DataSourceTransformPipe implements PipeTransform {

  transform(value: string, tenants: Tenant[], dropDown?: boolean) {
    if (value === 'NexLync' || (!value && dropDown)) {
      return tenants
        ? dropDown
          ? tenants.map(el => ({ label: el.name, value: el.name }))
          : tenants.map(el => el.name).join(', ')
        : [];
    } else if (value) {
      let tenant = value.split('MonthlyFile').join('');
      tenant = tenant.split('CommercialPhysicianFile').join('');
      tenant = tenant.split('PhysicianWeeklyFile').join('');
      return dropDown ? [{label: tenant, value: tenant}] : tenant;
    } else { return []; }
  }
}
